<div *ngIf="sessionData" class="PrefsGoals">
  <div class="PrefsGoals-header d-flex flex-row justify-content-between">
    <h4 class="title__page">Set Sales Goals</h4>
    <app-button
      text="Back to Inbox"
      color="blue"
      [style]="'outline'"
      size="small"
      route="/messages"></app-button>
  </div>
  <div class="PrefsGoals-form">
    <form [formGroup]="formGroup" class="d-flex flex-column">
      <div class="PrefsGoals-form-row">
        <p class="mb-0">What is the average value of a sale? (in dollars)</p>
        <div class="col col-12 col-md-5">
          <app-text-field
            type="number"
            placeholder="Avarage value"
            formControlName="pref_avg_sale"></app-text-field>
        </div>
      </div>
      <div class="PrefsGoals-form-row">
        <p class="mb-0">How long is your average sales cycle? (in months)</p>
        <div class="col col-12 col-md-5">
          <app-text-field
            placeholder="Average sales cycle"
            type="number"
            formControlName="pref_avg_cycle"></app-text-field>
        </div>
      </div>
      <div class="PrefsGoals-form-row">
        <p class="mb-0">What is your new appointment goal? (per month)</p>
        <div class="col col-12 col-md-5">
          <app-text-field
            placeholder="Appointment goal"
            type="number"
            formControlName="pref_appointment_goal"></app-text-field>
        </div>
      </div>
      <div class="PrefsGoals-form-row">
        <p class="mb-0">
          What percentage of appointments on average turn into sales? (e.g. .3 =
          30%)
        </p>
        <div class="col col-12 col-md-5">
          <app-text-field
            type="number"
            placeholder="Percentage of turn"
            formControlName="pref_sales_goal"></app-text-field>
        </div>
      </div>
      <div class="PrefsGoals-form-row">
        <p class="mb-0 font-weight-bolder">Contact goal per rep</p>
      </div>
      <div class="PrefsGoals-form-row">
        <p class="mb-0">Weekly</p>
        <div class="col col-12 col-md-5">
          <app-text-field
            type="number"
            placeholder="Weekly"
            formControlName="pref_goals_rep_weekly"></app-text-field>
        </div>
      </div>
      <div class="PrefsGoals-form-row">
        <p class="mb-0">Monthly</p>
        <div class="col col-12 col-md-5">
          <app-text-field
            type="number"
            placeholder="Montly"
            formControlName="pref_goals_rep_monthly"></app-text-field>
        </div>
      </div>
      <div class="PrefsGoals-form-buttons">
        <app-button
          class="PrefsGoals-form-button"
          [style]="cancelButtonProperties.style"
          [size]="cancelButtonProperties.size"
          [color]="cancelButtonProperties.color"
          [route]="cancelButtonProperties.route"
          [text]="cancelButtonProperties.text"></app-button>
        <app-button
          class="PrefsGoals-form-button"
          [style]="continueButtonProperties.style"
          [size]="continueButtonProperties.size"
          [color]="continueButtonProperties.color"
          [text]="continueButtonProperties.text"
          [Click]="continueButtonProperties.onClick"></app-button>
      </div>
    </form>
  </div>
</div>
